import { useCallback } from 'react';
import { useLocales } from 'src/locales';

/** Translation of a Campaign Leaks key (relative to dashboard.campaignLeaks). */
export type CampaignLeaksT = (key: string, options?: Record<string, unknown>) => string;

/** Translations of the Campaign Leaks pages, in en.json / fr.json under dashboard.campaignLeaks. */
export const useCampaignLeaksT = (): CampaignLeaksT => {
  const { t } = useLocales();
  return useCallback((key, options) => t(`dashboard.campaignLeaks.${key}`, options) as string, [t]);
};
